
import {
  defineComponent, PropType,
} from '@vue/composition-api';
import { hasExtensionManagerModel } from '@/lib/api/extension.service';
import { Platform, platforms, findPlatform } from '@/lib/platforms';

export default defineComponent({
  name: 'AppBar',

  props: {
    defaultOs: {
      type: String as PropType<string>,
      required: true,
    },
    defaultArch: {
      type: String as PropType<string>,
      default: undefined,
    },
    defaultQuery: {
      type: String as PropType<string>,
    },
    showQueryField: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    showOperatingSystemSelector: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    legacy: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  data() {
    return {
      platform: findPlatform(this.defaultOs, this.defaultArch)?.key,
      query: this.defaultQuery,
    };
  },

  activated() {
    this.platform = findPlatform(this.defaultOs, this.defaultArch)?.key;
  },

  methods: {
    onPlatformChange(key: string) {
      const platform = platforms.find((p) => p.key === key);
      if (platform) {
        this.$emit('update:platform', { os: platform.os, arch: platform.arch });
      }
    },
  },

  computed: {
    hasExtensionManagerModel(): boolean {
      return hasExtensionManagerModel();
    },
    operatingSystems(): Platform[] {
      return platforms;
    },
  },
});
